import {PrivateInterceptor} from '../../../interceptors/PrivateInterceptor';

export const getReferencias = async () =>{
    const result = await PrivateInterceptor(`Base/CuentasPorPagar/ReferenciaFacturacion`, 'GET')
    return result
}

export const getFacturasProveedor = async (IdProveedor, IdReferencia) =>{
    const result = await PrivateInterceptor(`Base/CuentasPorPagar/ReferenciaFacturacion/FacturacionProveedor`, 'POST' , {IdProveedor:IdProveedor, IdReferencia: IdReferencia})
    return result
}